import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from 'react';
import { useExperience } from './ExperienceContext';

export const DEFAULT_SITE_COPY: Record<string, string> = {
  'gallery.kicker': '图纸广场',
  'gallery.titleLine1': '找张喜欢的，',
  'gallery.titleLine2': '导入就能拼。',
  'gallery.intro': '找个图，加入我的图纸，开拼。',
  'gallery.openTool': '打开绘制工具',
  'gallery.permissionNote': '投稿仅对指定用户组开放；有权限的账号可在编辑页提交图纸。',
  'gallery.headerPromise': '广场仅保存压缩图纸',
  'gallery.sectionTitle': '图纸广场',
  'gallery.countTemplate': '{count} 张公开图纸',
  'gallery.memberCountTemplate': '已有 {count} 人注册加入',
  'gallery.searchPlaceholder': '搜索标题、作者或介绍',
  'gallery.loading': '正在整理广场图纸…',
  'gallery.emptyTitle': '广场正在上新',
  'gallery.emptyBody': '审核通过的图纸会显示在这里。',
  'gallery.noResultsTitle': '没有匹配的图纸',
  'gallery.noResultsBody': '换一个关键词试试。',
  'gallery.missingDescription': '这张图纸还没有介绍。',
  'gallery.defaultAuthor': '伊小满运营',
  'gallery.featuredBadge': '精选',
  'gallery.detailEyebrow': '精选图纸',
  'gallery.importButton': '加入我的图纸',
  'gallery.importingButton': '正在导入…',
  'gallery.deleteButton': '分享图纸',
  'publish.toolbarLabel': '投稿',
  'publish.title': '提交这张图纸',
  'publish.intro': '投稿仅对指定用户组开放。提交后由管理员审核，通过后才会在广场显示；服务器只保存图纸数据和预览图。',
  'publish.nameLabel': '图纸名称',
  'publish.descriptionLabel': '图纸说明',
  'publish.descriptionPlaceholder': '可以填写尺寸、用途或制作建议',
  'publish.pointsNote': '审核通过后会按当前规则发放创作积分。',
  'publish.pointsDisabledNote': '运营认证账号不参与积分奖励。',
  'publish.submitButton': '提交审核',
  'publish.submittingButton': '正在提交…',
  'publish.submittedNotice': '投稿已提交，管理员审核通过后会出现在广场。',
  'publish.permissionDenied': '当前账号不在可投稿用户组中，请联系管理员开通。',
  'community.sortFeatured': '精选', 'community.sortPopular': '热门', 'community.sortLatest': '最新',
  'community.publisher': '发布者', 'community.like': '赞', 'community.favorite': '收藏',
  'account.currentLabel': '当前账号', 'account.groupLabel': '用户组', 'account.ordinaryGroup': '普通用户', 'account.points': '我的积分', 'account.pointsDisabled': '积分系统未开启', 'account.profile': '账号资料', 'account.creatorPage': '我的作者主页', 'account.favorites': '我的收藏', 'account.membership': '会员方案', 'account.logout': '退出登录',
  'verification.yellow': '个人认证', 'verification.blue': '运营认证',
  'store.title': '积分商城', 'store.intro': '积分可兑换活动商品；商品和库存由后台管理。', 'store.emptyTitle': '商品准备中', 'store.emptyBody': '后台上架商品后会显示在这里。',
  'store.balance': '当前积分', 'store.noDescription': '暂无商品说明', 'store.unlimited': '不限量', 'store.stockTemplate': '剩余 {count}', 'store.pointsTemplate': '{count} 积分', 'store.rulesTitle': '积分怎么获得', 'store.ruleThresholdTemplate': '门槛 {threshold}，单张图纸最多 {max} 分。', 'store.historyTitle': '我的兑换', 'store.historyEmpty': '还没有兑换记录。',
  'center.paletteKicker': '色卡中心', 'center.paletteTitle': '色卡中心', 'center.paletteIntro': '按品牌与系列查看实际拼豆用色、色号和颜色值。跨品牌转换会在逐色校对完成后开放，原图纸始终保留原品牌编号。',
  'center.paletteSection': '品牌与系列', 'center.paletteSearch': '搜索品牌、系列或色号',
  'center.tutorialKicker': '拼豆教程', 'center.tutorialTitle': '拼豆教程中心', 'center.tutorialIntro': '围绕选图、备料、底板定位、摆豆检查与熨烫定型，整理能在线下制作时随手查阅的实用指南。',
  'center.tutorialSection': '全部拼豆教程', 'center.tutorialSearch': '搜索线下制作教程',
  'center.adminMaintained': '后台统一维护', 'center.publishedTrace': '发布内容可追踪', 'center.viewDetail': '查看详情',
  'center.emptyPalette': '后台发布色卡后会显示在这里。', 'center.emptyTutorial': '后台发布拼豆教程后会显示在这里。',
  'products.kicker': '合作商品',
  'products.titleLine1': '好材料，好工具，',
  'products.titleLine2': '少走一点弯路。',
  'products.intro': '这里集中展示合作商家的拼豆材料、工具和周边。我们负责整理信息与核验展示资料，实际购买在商家渠道完成。',
  'products.trustAssets': '合作资料留档', 'products.trustJump': '跳转商家购买', 'products.trustQr': '支持扫码前往',
  'products.sectionEyebrow': 'COOPERATIVE GOODS', 'products.sectionTitle': '合作商品', 'products.countTemplate': '{count} 件商品',
  'products.statementTitle': '展示与购买声明',
  'products.statement': '伊小满拼豆仅提供合作商品信息展示与商家入口，不参与下单、收款、发货或售后。商品价格、库存、活动及服务承诺以合作商家页面为准，请在购买前自行核验。',
  'products.loading': '正在读取合作商品…', 'products.errorTitle': '暂时无法读取商品',
  'products.emptyTitle': '合作商品正在准备中', 'products.emptyBody': '商品资料审核并发布后会显示在这里。',
  'products.defaultMerchant': '合作商家', 'products.defaultSubtitle': '查看商品详情与商家购买方式', 'products.viewDetail': '查看详情',
  'products.detailCategory': '合作商品', 'products.descriptionTitle': '商品介绍', 'products.highlightsTitle': '商品亮点',
  'products.qualificationButton': '查看商家资质', 'products.qualificationTitle': '商家资质', 'products.qualificationEmpty': '商家暂未提供资质图片。',
  'products.qrButton': '扫码购买', 'products.qrTitle': '扫码购买', 'products.qrEmpty': '当前商品暂未提供购买二维码。',
  'products.externalButton': '前往商家页面', 'products.linkPending': '商家跳转入口准备中',
  'products.purchaseStatement': '购买声明', 'products.leaveNote': '离开本站后，请留意商家名称、收款主体和售后规则。',
  'favorites.title': '我的收藏', 'favorites.intro': '收藏的公开图纸会保存在账号中。', 'favorites.emptyTitle': '还没有收藏', 'favorites.emptyBody': '在图纸广场点收藏后，会显示在这里。',
  'creator.emptyBio': '这位作者还没有填写简介。', 'creator.patterns': '公开图纸', 'creator.likes': '获赞', 'creator.favorites': '被收藏', 'creator.imports': '被导入', 'creator.loading': '正在读取作者主页…', 'creator.patternLikesTemplate': '{count} 赞',
  'profile.title': '账号资料', 'profile.uploadAvatar': '上传头像', 'profile.resetAvatar': '恢复默认', 'profile.avatarNote': '自动裁成正方形并压缩为 WebP，服务器不保存原图。', 'profile.nickname': '昵称', 'profile.bioLabel': '作者简介', 'profile.bioPlaceholder': '简单介绍你的图纸风格或擅长内容', 'profile.save': '保存资料', 'profile.saving': '正在保存…',
  'feedback.open': '意见反馈', 'feedback.close': '关闭反馈', 'feedback.title': '意见反馈', 'feedback.intro': '告诉我们哪里不顺手，具体页面和复现方式会帮助我们更快处理。', 'feedback.contentLabel': '反馈内容', 'feedback.contentPlaceholder': '请描述遇到的问题或建议，至少 5 个字', 'feedback.contactLabel': '联系方式（选填）', 'feedback.contactPlaceholder': '微信、QQ 或邮箱', 'feedback.submit': '提交反馈', 'feedback.submitting': '正在提交', 'feedback.success': '已收到，谢谢你的反馈。', 'feedback.error': '提交失败，请稍后再试'
};

type CopyFunction = (key: string, variables?: Record<string, string | number>) => string;
const SiteCopyContext = createContext<CopyFunction>((key) => DEFAULT_SITE_COPY[key] || key);

export function SiteCopyProvider({ children }: { children: ReactNode }) {
  const { locale } = useExperience();
  const [values, setValues] = useState(DEFAULT_SITE_COPY);
  useEffect(() => {
    const controller = new AbortController();
    fetch(`/api/site-copy${locale ? `?locale=${encodeURIComponent(locale)}` : ''}`, { credentials: 'include', signal: controller.signal, cache: 'no-store' })
      .then((response) => response.ok ? response.json() : null)
      .then((data) => { if (data?.copy) setValues({ ...DEFAULT_SITE_COPY, ...data.copy }); })
      .catch(() => undefined);
    return () => controller.abort();
  }, [locale]);
  const copy = useMemo<CopyFunction>(() => (key, variables = {}) => {
    let value = values[key] || DEFAULT_SITE_COPY[key] || key;
    for (const [name, replacement] of Object.entries(variables)) value = value.replaceAll(`{${name}}`, String(replacement));
    return value;
  }, [values]);
  return <SiteCopyContext.Provider value={copy}>{children}</SiteCopyContext.Provider>;
}

export function useSiteCopy() { return useContext(SiteCopyContext); }
